export const containsSameItems = (a: unknown[], b: unknown[]) =>
  a.length === b.length &&
  a.every((v) => a.filter((e) => e === v).length === b.filter((e) => e === v).length)
